import React, { useEffect, useState, lazy, memo, createElement } from 'react';
import { Check, X, ShieldCheck, Star, Target, Smartphone, Palette, Flame, Calendar, Search, Trophy, Edit3, ChevronDown, Quote, Clock, Zap, Brain, BookOpen, GraduationCap, Sparkles, ClipboardList, Users, Heart, Map, AlertCircle, FileText, Lightbulb } from 'lucide-react';
const socialProofData = [{
  name: 'Federica K.',
  city: 'Napoli',
  time: '3 min fa'
}, {
  name: 'Marco R.',
  city: 'Milano',
  time: '5 min fa'
}, {
  name: 'Giulia T.',
  city: 'Roma',
  time: '7 min fa'
}, {
  name: 'Alessandro M.',
  city: 'Torino',
  time: '12 min fa'
}, {
  name: 'Chiara B.',
  city: 'Firenze',
  time: '15 min fa'
}, {
  name: 'Luca P.',
  city: 'Bologna',
  time: '18 min fa'
}, {
  name: 'Valentina S.',
  city: 'Palermo',
  time: '22 min fa'
}, {
  name: 'Davide C.',
  city: 'Genova',
  time: '25 min fa'
}, {
  name: 'Sofia L.',
  city: 'Venezia',
  time: '28 min fa'
}, {
  name: 'Andrea F.',
  city: 'Verona',
  time: '31 min fa'
}];
function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const initialDelay = setTimeout(() => setVisible(true), 4000);
    return () => clearTimeout(initialDelay);
  }, [dismissed]);
  useEffect(() => {
    if (dismissed || !visible) return;
    const hideTimer = setTimeout(() => setVisible(false), 5000);
    return () => clearTimeout(hideTimer);
  }, [visible, dismissed]);
  useEffect(() => {
    if (dismissed || visible) return;
    const showTimer = setTimeout(() => {
      setCurrentIndex(prev => (prev + 1) % socialProofData.length);
      setVisible(true);
    }, 8000);
    return () => clearTimeout(showTimer);
  }, [visible, dismissed]);
  if (dismissed) return null;
  const person = socialProofData[currentIndex];
  return <div className={`fixed bottom-4 left-4 z-50 max-w-sm transition-all duration-500 ease-out ${visible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0 pointer-events-none'}`} data-id="element-0">
      <div className="bg-dark-800 border border-white/10 rounded-xl p-4 pr-10 shadow-2xl shadow-black/50 relative" data-id="element-1">
        <button onClick={() => setDismissed(true)} className="absolute top-3 right-3 text-gray-500 hover:text-gray-300 transition-colors" aria-label="Chiudi" data-id="element-2">
          <X className="w-4 h-4" data-id="element-3" />
        </button>
        <div className="flex items-start gap-3" data-id="element-4">
          <div className="w-10 h-10 rounded-full bg-orange-500/20 flex items-center justify-center shrink-0" data-id="element-5">
            <span className="text-orange-400 text-lg" data-id="element-6">👩‍🏫</span>
          </div>
          <div className="flex-1 min-w-0" data-id="element-7">
            <p className="text-sm text-gray-300" data-id="element-8">
              <span className="font-bold text-white" data-id="element-9">{person.name}</span>{' '}
              <span className="text-gray-500" data-id="element-10">da {person.city}</span>{' '}
              <span className="text-gray-500" data-id="element-11">🇮🇹</span>
            </p>
            <p className="text-sm text-gray-400 mt-1" data-id="element-12">
              Ha appena acquistato{' '}
              <span className="text-gold-400 font-semibold" data-id="element-13">
                Docente PRO: Sistema IA Universale
              </span>{' '}
              📚
            </p>
            <p className="text-xs text-gray-500 mt-2 flex items-center gap-1.5" data-id="element-14">
              <span className="w-2 h-2 rounded-full bg-emerald-500 inline-block animate-pulse" data-id="element-15"></span>
              ACQUISTO VERIFICATO · {person.time}
            </p>
          </div>
        </div>
      </div>
    </div>;
}
const CTAButton = ({
  children,
  subtext,
  scrollTo
}: {
  children: React.ReactNode;
  subtext?: string;
  scrollTo?: string;
}) => {
  const handleClick = () => {
    if (scrollTo) {
      const el = document.getElementById(scrollTo);
      if (el) el.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="flex flex-col items-center w-full max-w-xl mx-auto mt-8 mb-6" data-id="element-16">
      <button onClick={handleClick} className="w-full group relative inline-flex items-center justify-center px-8 py-5 text-lg font-bold text-white transition-all duration-200 bg-gradient-to-b from-emerald-400 to-emerald-600 border-b-4 border-emerald-800 rounded-xl hover:from-emerald-300 hover:to-emerald-500 hover:-translate-y-1 active:translate-y-0 active:border-b-0 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500 focus:ring-offset-dark-900 shadow-[0_0_40px_rgba(16,185,129,0.3)] hover:shadow-[0_0_60px_rgba(16,185,129,0.5)]" data-id="element-17">
        <span className="flex items-center gap-2 text-xl tracking-wide uppercase text-shadow-sm" data-id="element-18">
          {children}
        </span>
      </button>
      {subtext && <p className="mt-3 text-sm font-medium text-gray-400 flex items-center gap-2 text-center" data-id="element-19">
          {subtext}
        </p>}
    </div>;
};
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/vcFpgY3u8JLANBpvfLqj4j/mocap_inteligencia_sin_fondo.webp';
export function App() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  useEffect(() => {
    const preconnect1 = document.createElement('link');
    preconnect1.rel = 'preconnect';
    preconnect1.href = 'https://fonts.googleapis.com';
    const preconnect2 = document.createElement('link');
    preconnect2.rel = 'preconnect';
    preconnect2.href = 'https://fonts.gstatic.com';
    preconnect2.crossOrigin = 'anonymous';
    const preconnect3 = document.createElement('link');
    preconnect3.rel = 'preconnect';
    preconnect3.href = 'https://cdn.magicpatterns.com';
    const preloadImg = document.createElement('link');
    preloadImg.rel = 'preload';
    preloadImg.as = 'image';
    preloadImg.href = HERO_IMAGE;
    preloadImg.type = 'image/webp';
    document.head.prepend(preloadImg);
    document.head.prepend(preconnect3);
    document.head.prepend(preconnect2);
    document.head.prepend(preconnect1);
  }, []);
  // Meta Pixel — deferred to reduce TBT
  useEffect(() => {
    const loadPixel = () => {
      if ((window as any).fbq) return;
      const f = window as any;
      const n: any = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
      n('init', '4445454969060534');
      n('track', 'PageView');
    };
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(loadPixel, {
        timeout: 3000
      });
    } else {
      setTimeout(loadPixel, 2500);
    }
  }, []);
  const faqs = [{
    q: 'Non so nulla di intelligenza artificiale. È per me?',
    a: 'Assolutamente sì. Il Tomo 1 parte da zero assoluto. Se sai usare WhatsApp, sai già abbastanza per iniziare.'
  }, {
    q: 'Non ho tempo per studiare un altro corso.',
    a: 'Non è un corso. È un sistema operativo. Lo apri, segui le istruzioni, applichi i prompt. Nessuna teoria infinita. Solo pratica immediata.'
  }, {
    q: 'Funziona per la mia materia e il mio livello scolastico?',
    a: 'Sì. Il sistema è stato progettato per ogni ordine e grado: nido, primaria, secondaria, università e formazione professionale.'
  }, {
    q: 'Devo comprare strumenti costosi?',
    a: 'No. Il sistema funziona con strumenti gratuiti già disponibili. Non serve nessun abbonamento aggiuntivo.'
  }, {
    q: 'In quanto tempo vedo i risultati?',
    a: 'Dal primo giorno. Molti docenti risparmiano 2-3 ore già nella prima settimana.'
  }];
  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };
  const tomos = [{
    icon: Sparkles,
    num: '1',
    title: 'Fondamenti e Prompt IA',
    desc: "Parti da zero e diventa operativo in 7 giorni. Mentalità IA, configurazione strumenti, formula R-C-O-F per prompt perfetti, etica e privacy nel contesto scolastico italiano, piano d'azione di 7 giorni."
  }, {
    icon: Calendar,
    num: '2',
    title: 'Pianificazione Totale: 365 giorni in 1 ora',
    desc: 'Non sprecare mai più una domenica. Prompt Maestro Annuale, UDA pronte in 20 minuti, Metodo della Domenica Libera, calendario 2025-2026 integrato e prompt di emergenza.'
  }, {
    icon: Lightbulb,
    num: '3',
    title: 'Il Laboratorio di Classe Creativa',
    desc: 'Trasforma ogni lezione in esperienza memorabile. Le 5 fasi emotive, storytelling didattico, gamification, escape room, pensiero critico e biblioteca di attività per ogni livello.'
  }, {
    icon: ClipboardList,
    num: '4',
    title: 'Correggere meno, valutare meglio',
    desc: 'Riduci a metà il tempo di correzione senza perdere qualità. Rubriche in 5 minuti, feedback personalizzato istantaneo, verifiche differenziate e comunicazione con le famiglie.'
  }, {
    icon: Heart,
    num: '5',
    title: 'Il Docente Inclusivo: BES, DSA e Diversità',
    desc: 'Didattica su misura per ogni studente. Quadro normativo italiano, Prompt Maestro per PDP, adattamento materiali in tempo reale, tecnologie assistive e co-teaching.'
  }, {
    icon: Zap,
    num: '6',
    title: 'Produttività Docente: meno stress, più vita',
    desc: 'Hai scelto di insegnare, non di sopravvivere. Gestione email e circolari con IA, automazione documenti, routine sostenibili, protezione del week-end e Piano di Benessere Docente.'
  }];
  const bonuses = [{
    icon: BookOpen,
    title: 'Bonus 1 — Glossario Visivo del Docente IA',
    desc: "Tutti i termini dell'IA spiegati in modo semplice e visivo."
  }, {
    icon: Users,
    title: 'Bonus 2 — 30 Frasi Pronte per Parlare di IA',
    desc: 'Per colleghi, dirigenti e famiglie. Sicurezza in ogni conversazione.'
  }, {
    icon: Map,
    title: 'Bonus 3 — Mappa Rapida degli Strumenti 2026',
    desc: 'I migliori tool gratuiti e a pagamento, già selezionati e categorizzati.'
  }, {
    icon: Check,
    title: 'Bonus 4 — Checklist di Attivazione Rapida',
    desc: 'Inizia subito senza confusione. Step by step verso il primo risultato.'
  }, {
    icon: AlertCircle,
    title: 'Bonus 5 — Manuale degli Errori che Fanno Perdere Tempo',
    desc: 'Evita le trappole più comuni del docente digitale italiano.'
  }, {
    icon: Edit3,
    title: 'Bonus 6 — Piano Personale di Adozione IA',
    desc: 'Il tuo percorso personalizzato passo dopo passo, dal giorno 1 al giorno 30.'
  }];
  return <div className="min-h-screen bg-dark-900 text-gray-300 selection:bg-gold-500 selection:text-black pb-20 overflow-x-hidden" data-id="element-20">
      {/* Attention Bar */}
      <div className="w-full bg-dark-800 border-b border-white/5 py-3 px-4 flex justify-center items-center z-50" data-id="element-21">
        <div className="flex items-center gap-3 max-w-4xl mx-auto text-center" data-id="element-22">
          <div className="w-2.5 h-2.5 rounded-full bg-red-500 animate-pulse-fast shrink-0 shadow-[0_0_10px_rgba(239,68,68,0.8)]" data-id="element-23"></div>
          <p className="text-xs md:text-sm font-semibold tracking-wider text-gray-300 uppercase" data-id="element-24">
            ATTENZIONE: DOCENTI ITALIANI CHE VOGLIONO LAVORARE MENO, INSEGNARE
            MEGLIO E RITROVARE LA LORO VITA
          </p>
        </div>
      </div>

      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-6 md:pt-20" data-id="element-25">
        {/* Hero */}
        <div className="text-center space-y-5 md:space-y-8 mb-8 md:mb-12" data-id="element-26">
          <h1 className="text-3xl md:text-6xl lg:text-7xl font-black text-white leading-[1.1] tracking-tight" data-id="element-27">
            Sei un docente che lavora troppo, dorme poco e ha ancora{' '}
            <span className="gold-gradient-text" data-id="element-28">47 compiti da correggere</span>{' '}
            sul comodino?
          </h1>

          <div className="max-w-3xl mx-auto space-y-4 md:space-y-6" data-id="element-29">
            <div className="relative pl-5 md:pl-6 py-2 text-left" data-id="element-30">
              <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-gradient-to-b from-gold-400 to-gold-600 rounded-full" data-id="element-31"></div>
              <p className="text-base md:text-xl text-gray-300 leading-relaxed font-medium" data-id="element-32">
                Quello che stai per leggere ha già cambiato il modo di lavorare
                di{' '}
                <span className="text-white font-bold" data-id="element-33">
                  migliaia di insegnanti in Italia
                </span>
                . E oggi può cambiare anche il tuo.
              </p>
            </div>
            <p className="text-lg md:text-2xl font-bold text-gold-400" data-id="element-34">
              Docente PRO: Sistema IA Universale
            </p>
          </div>
        </div>

        {/* Product image + social proof */}
        <div className="flex flex-col items-center mb-16" data-id="element-35">
          <div className="relative w-full max-w-md sm:max-w-lg md:max-w-xl mx-auto mb-8 aspect-square" data-id="element-36">
            <div className="absolute inset-0 bg-gold-500/10 blur-[100px] rounded-full pointer-events-none blur-glow" data-id="element-37"></div>
            <img src={HERO_IMAGE} alt="Docente PRO: Sistema IA Universale Bundle" width={1080} height={1080} fetchPriority="high" decoding="async" className="relative z-10 w-full h-full object-contain drop-shadow-2xl md:hover:scale-[1.02] transition-transform duration-500" data-id="element-38" />
          </div>

          <div className="flex flex-col items-center space-y-3 mb-8" data-id="element-39">
            <div className="flex items-center gap-1 text-gold-400" data-id="element-40">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-current" data-id="element-41" />)}
            </div>
            <p className="text-white font-semibold text-lg" data-id="element-42">
              4.9/5 (+2.300 Docenti Soddisfatti)
            </p>
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-orange-500/10 border border-orange-500/20 text-orange-400 font-medium text-sm text-center" data-id="element-43">
              <Flame className="w-4 h-4 shrink-0" data-id="element-44" />
              89 docenti hanno scelto questo Sistema oggi
            </div>
          </div>

          <CTAButton subtext="⚡ Accesso Immediato • 🛡️ Garanzia 7 Giorni • 💳 Pagamento Unico" scrollTo="offerta" data-id="element-45">
            🚀 SÌ, VOGLIO DOCENTE PRO ADESSO
          </CTAButton>

          <div className="mt-6 flex flex-col items-center gap-3 text-center" data-id="element-46">
            <div className="flex gap-2 text-2xl" data-id="element-47">📚 ✏️ 🎓 💡 🇮🇹</div>
            <p className="text-sm text-gray-400 max-w-md" data-id="element-48">
              Il primo sistema completo in italiano per docenti che vogliono
              usare l'IA davvero.
            </p>
          </div>
        </div>

        {/* Opening narrative — 3 blocks */}
        <div className="mb-20 space-y-6" data-id="element-49">
          <div className="glass-panel p-8 md:p-10 rounded-2xl border-gold-500/20 relative overflow-hidden" data-id="element-50">
            <div className="absolute top-0 left-0 w-2 h-full bg-gradient-to-b from-gold-400 to-gold-600" data-id="element-51"></div>
            <Quote className="absolute top-6 right-6 w-24 h-24 text-white/5 rotate-180 pointer-events-none" data-id="element-52" />
            <p className="text-lg md:text-xl text-gray-300 leading-relaxed relative z-10 font-medium" data-id="element-53">
              <span className="text-white font-bold" data-id="element-54">Lasciami indovinare.</span>{' '}
              La tua domenica non è mai davvero libera. Hai sempre qualcosa da
              pianificare, qualcosa da correggere, qualcosa da consegnare entro
              lunedì. La tua borsa è piena di fogli. Il tuo laptop ha 23 schede
              aperte. Hai scelto questa professione per fare la differenza —{' '}
              <span className="text-gold-400 font-bold" data-id="element-55">
                non per annegare nella burocrazia
              </span>
              . Eppure eccoti qui. Di nuovo. Con il week-end che svanisce
              davanti ai tuoi occhi.
            </p>
          </div>

          <div className="glass-panel p-8 md:p-10 rounded-2xl border-white/10 relative overflow-hidden" data-id="element-56">
            <p className="text-lg md:text-xl text-gray-300 leading-relaxed font-medium" data-id="element-57">
              <span className="text-white font-bold" data-id="element-58">
                Il problema non sei tu.
              </span>{' '}
              Non sei lento. Non sei disorganizzato. Non sei incapace.{' '}
              <span className="text-white font-bold" data-id="element-59">
                Il problema è che nessuno ti ha mai dato un sistema.
              </span>{' '}
              Ti hanno formato su pedagogia, didattica, discipline. Ma nessuno
              ti ha mai detto come gestire pianificazione, valutazione,
              documentazione, PDP, UDA, riunioni, circolari e verifiche. E
              adesso, nell'era dell'IA, ti ritrovi a fare le stesse cose di
              sempre, perdendo lo stesso tempo di sempre.
            </p>
          </div>

          <div className="glass-panel p-8 md:p-10 rounded-2xl border-gold-500/20 relative overflow-hidden" data-id="element-60">
            <div className="absolute top-0 left-0 w-2 h-full bg-gradient-to-b from-gold-400 to-gold-600" data-id="element-61"></div>
            <p className="text-lg md:text-xl text-gray-300 leading-relaxed font-medium" data-id="element-62">
              Ma cosa succederebbe se potessi{' '}
              <span className="text-white font-bold" data-id="element-63">
                pianificare l'intero anno scolastico in meno di un'ora
              </span>
              ? Se le tue verifiche si correggessero in metà tempo? Se ogni
              lunedì arrivassi in classe con tutto già pronto, ogni materiale
              già adattato per BES e DSA?{' '}
              <span className="text-gold-400 font-bold" data-id="element-64">
                Non è fantascienza.
              </span>{' '}
              È esattamente quello che fa l'IA quando hai un sistema. L'IA è
              gratis e potente. Manca solo il metodo per usarla davvero. Fino ad
              oggi.
            </p>
          </div>
        </div>

        {/* Comparison Table */}
        <div className="mb-20" data-id="element-65">
          <h2 className="text-3xl font-bold text-center text-white mb-10" data-id="element-66">
            La tua trasformazione
          </h2>
          <div className="glass-panel rounded-2xl overflow-hidden" data-id="element-67">
            <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-68">
              <div className="p-6 md:p-8 bg-dark-800/50 border-b md:border-b-0 md:border-r border-white/5" data-id="element-69">
                <h3 className="text-xl font-bold text-gray-400 mb-6 flex items-center gap-2" data-id="element-70">
                  SENZA IL SISTEMA
                  <span className="text-sm font-normal text-gray-500 block mt-1" data-id="element-71">
                    (Cosa ti costa oggi)
                  </span>
                </h3>
                <ul className="space-y-6" data-id="element-72">
                  {['Domeniche perse a pianificare e correggere senza fine.', 'Ore sprecate cercando attività su Google da adattare.', 'Stesse relazioni ogni anno, cambiando solo le date.', 'PDP, UDA e burocrazia che mangiano il tuo tempo libero.'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-400" data-id="element-73">
                      <div className="mt-1 bg-red-500/10 p-1 rounded-full shrink-0" data-id="element-74">
                        <X className="w-4 h-4 text-red-500" data-id="element-75" />
                      </div>
                      <span className="leading-relaxed" data-id="element-76">{item}</span>
                    </li>)}
                </ul>
              </div>

              <div className="p-6 md:p-8 bg-emerald-900/10 relative overflow-hidden" data-id="element-77">
                <div className="absolute top-0 right-0 w-64 h-64 bg-emerald-500/5 blur-[80px] rounded-full pointer-events-none blur-glow" data-id="element-78"></div>
                <h3 className="text-xl font-bold text-emerald-400 mb-6 flex items-center gap-2 relative z-10" data-id="element-79">
                  CON DOCENTE PRO
                  <span className="text-sm font-normal text-emerald-500/70 block mt-1" data-id="element-80">
                    (La tua vita domani)
                  </span>
                </h3>
                <ul className="space-y-6 relative z-10" data-id="element-81">
                  {["Pianificazione annuale completa in meno di un'ora.", 'Verifiche e rubriche generate in 5 minuti con prompt pronti.', 'PDP completi e materiali adattati per BES/DSA al volo.', 'Domeniche libere e week-end protetti, davvero.'].map((item, i) => <li key={i} className="flex items-start gap-3 text-white font-medium" data-id="element-82">
                      <div className="mt-1 bg-emerald-500/20 p-1 rounded-full shrink-0" data-id="element-83">
                        <Check className="w-4 h-4 text-emerald-400" data-id="element-84" />
                      </div>
                      <span className="leading-relaxed" data-id="element-85">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Per te se */}
        <div className="mb-20" data-id="element-86">
          <h2 className="text-3xl font-bold text-center text-white mb-10" data-id="element-87">
            Questo sistema è per te se...
          </h2>
          <div className="glass-panel p-8 rounded-2xl border-white/10" data-id="element-88">
            <ul className="space-y-5" data-id="element-89">
              {['Sei stanco di sacrificare i tuoi week-end per pianificazioni e correzioni infinite.', "Vuoi usare l'intelligenza artificiale ma non sai da dove iniziare nel contesto scolastico italiano.", 'Insegni in qualunque ordine e grado: nido, primaria, secondaria, università, formazione professionale.', 'Vuoi tornare a fare il motivo per cui hai scelto questa professione: fare la differenza nei tuoi studenti.'].map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-90">
                  <div className="mt-1 bg-gold-500/20 p-1.5 rounded-full shrink-0" data-id="element-91">
                    <Check className="w-5 h-5 text-gold-400" data-id="element-92" />
                  </div>
                  <span className="text-lg text-gray-300 leading-relaxed" data-id="element-93">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Cosa otterrai */}
        <div className="mb-20" data-id="element-94">
          <h2 className="text-3xl font-bold text-center text-white mb-12" data-id="element-95">
            Cosa otterrai con Docente PRO:
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-96">
            {[{
            icon: Zap,
            title: "Sistema Operativo Pronto all'Uso",
            desc: 'Non un corso. Non una teoria. Un sistema che apri, leggi e applichi. Risultati dal primo giorno.',
            color: 'text-amber-400',
            bg: 'bg-amber-400/10'
          }, {
            icon: Trophy,
            title: 'Strumenti 100% Gratuiti',
            desc: 'Funziona con tool gratuiti già disponibili. Nessun abbonamento aggiuntivo, nessuna spesa extra.',
            color: 'text-emerald-400',
            bg: 'bg-emerald-400/10'
          }, {
            icon: Smartphone,
            title: 'Tutto in Italiano, per la Scuola Italiana',
            desc: 'Normativa, BES, DSA, PDP, UDA, calendario 2025-2026. Pensato per il contesto scolastico reale.',
            color: 'text-blue-400',
            bg: 'bg-blue-400/10'
          }, {
            icon: Target,
            title: 'Prompt Pronti e Testati',
            desc: 'Centinaia di prompt copia-incolla per pianificazione, valutazione, comunicazioni e inclusione.',
            color: 'text-purple-400',
            bg: 'bg-purple-400/10'
          }].map((item, i) => <div key={i} className="glass-panel p-6 rounded-2xl border-white/5 hover:border-white/10 transition-colors" data-id="element-97">
                <div className={`w-12 h-12 rounded-xl ${item.bg} flex items-center justify-center mb-4`} data-id="element-98">
                  <item.icon className={`w-6 h-6 ${item.color}`} data-id="element-99" />
                </div>
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-100">
                  {item.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-101">{item.desc}</p>
              </div>)}
          </div>
        </div>

        {/* 6 Tomi */}
        <div className="mb-20" data-id="element-102">
          <div className="text-center mb-12" data-id="element-103">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-104">
              Cosa include il sistema <br data-id="element-105" />
              <span className="gold-gradient-text" data-id="element-106">"Docente PRO"</span>?
            </h2>
            <p className="text-gray-400 text-lg" data-id="element-107">
              6 Tomi operativi in PDF — pronti da consultare su tablet,
              cellulare o stampati.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-108">
            {tomos.map((item, i) => <div key={i} className="glass-panel p-8 rounded-2xl relative overflow-hidden group" data-id="element-109">
                <div className="absolute top-0 right-0 w-32 h-32 bg-gold-500/5 rounded-full blur-3xl group-hover:bg-gold-500/10 transition-colors blur-glow" data-id="element-110"></div>
                <div className="flex items-center gap-4 mb-5 relative z-10" data-id="element-111">
                  <div className="w-14 h-14 rounded-xl bg-dark-800 border border-white/10 flex items-center justify-center shrink-0" data-id="element-112">
                    <item.icon className="w-7 h-7 text-gold-400" data-id="element-113" />
                  </div>
                  <span className="text-xs font-bold text-gold-400 uppercase tracking-widest bg-gold-500/10 px-3 py-1 rounded-full border border-gold-500/20" data-id="element-114">
                    Tomo {item.num}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-white mb-3 relative z-10" data-id="element-115">
                  {item.title}
                </h3>
                <p className="text-gray-400 leading-relaxed relative z-10 text-sm" data-id="element-116">
                  {item.desc}
                </p>
                <p className="mt-4 text-xs text-emerald-400 font-bold relative z-10" data-id="element-117">
                  Valore reale: €47
                </p>
              </div>)}
          </div>
        </div>

        {/* Bonuses */}
        <div className="mb-24 relative" data-id="element-118">
          <div className="absolute inset-0 bg-gold-500/5 blur-[120px] rounded-full pointer-events-none blur-glow" data-id="element-119"></div>
          <div className="glass-panel border-gold-500/20 p-8 md:p-12 rounded-3xl relative z-10" data-id="element-120">
            <div className="text-center mb-12" data-id="element-121">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-122">
                6 Bonus Esclusivi Inclusi
              </h2>
              <p className="text-gold-400 font-medium text-lg uppercase tracking-wider" data-id="element-123">
                (Senza costi extra)
              </p>
              <div className="inline-block mt-4 px-6 py-2 rounded-full bg-dark-800 border border-white/10" data-id="element-124">
                <p className="text-gray-300 font-semibold" data-id="element-125">
                  Valore totale dei bonus:{' '}
                  <span className="text-white" data-id="element-126">€ 102</span>
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-127">
              {bonuses.map((bonus, i) => <div key={i} className="flex flex-col sm:flex-row items-start gap-5 p-6 rounded-2xl bg-dark-800/80 border border-white/5 hover:border-gold-500/30 transition-colors" data-id="element-128">
                  <div className="w-12 h-12 rounded-xl bg-gold-500/10 flex items-center justify-center shrink-0 border border-gold-500/20" data-id="element-129">
                    <bonus.icon className="w-6 h-6 text-gold-400" data-id="element-130" />
                  </div>
                  <div className="flex-1" data-id="element-131">
                    <div className="flex items-center justify-between gap-2 mb-2" data-id="element-132">
                      <h4 className="text-white font-bold text-lg leading-tight" data-id="element-133">
                        {bonus.title}
                      </h4>
                      <span className="px-2.5 py-1 text-[10px] font-black bg-emerald-500/20 text-emerald-400 rounded uppercase tracking-wider shrink-0" data-id="element-134">
                        Gratis
                      </span>
                    </div>
                    <p className="text-gray-400 text-sm leading-relaxed" data-id="element-135">
                      {bonus.desc}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        {/* Urgency */}
        <div className="mb-16" data-id="element-136">
          <div className="glass-panel border-red-500/30 p-8 md:p-10 rounded-2xl relative overflow-hidden" data-id="element-137">
            <div className="absolute top-0 left-0 w-2 h-full bg-gradient-to-b from-red-400 to-red-600" data-id="element-138"></div>
            <h3 className="text-2xl font-bold text-white mb-4 flex items-center gap-3" data-id="element-139">
              <AlertCircle className="w-7 h-7 text-red-400 shrink-0" data-id="element-140" />
              Attenzione: offerta a tempo limitato
            </h3>
            <p className="text-gray-300 leading-relaxed mb-4" data-id="element-141">
              Ogni settimana che passa senza un sistema è una settimana in cui:
            </p>
            <ul className="space-y-3" data-id="element-142">
              {['Perdi ore preziose che non torneranno mai', 'I tuoi colleghi ti superano tecnologicamente', 'Il tuo stress si accumula senza soluzione', 'I tuoi studenti meritano di più'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-300" data-id="element-143">
                  <X className="w-4 h-4 text-red-400 mt-1 shrink-0" data-id="element-144" />
                  <span data-id="element-145">{item}</span>
                </li>)}
            </ul>
            <p className="text-white font-bold mt-6 leading-relaxed" data-id="element-146">
              La scuola non aspetta. I tuoi studenti non aspettano. E il tuo
              tempo non aspetta.
            </p>
          </div>
        </div>

        {/* Pricing */}
        <div id="offerta" className="mb-16 text-center scroll-mt-8" data-id="element-147">
          <h2 className="text-3xl font-bold text-white mb-10" data-id="element-148">
            L'Offerta "Docente PRO"
          </h2>

          <div className="inline-block w-full max-w-2xl glass-panel p-8 md:p-12 rounded-3xl border-gold-500/40 relative overflow-hidden text-left shadow-[0_0_50px_rgba(251,191,36,0.05)]" data-id="element-149">
            <div className="absolute top-0 right-0 bg-red-500 text-white text-xs font-bold px-12 py-2 rotate-45 translate-x-10 translate-y-6 shadow-lg z-20 tracking-wider" data-id="element-150">
              95% OFF
            </div>

            <div className="flex justify-center mb-8" data-id="element-151">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-gold-500/20 border border-gold-500/30 text-gold-400 text-sm font-bold tracking-wide uppercase" data-id="element-152">
                <Star className="w-4 h-4 fill-current" data-id="element-153" />
                LA SCELTA PIÙ POPOLARE
              </div>
            </div>

            <p className="text-gray-400 font-bold uppercase tracking-widest text-sm mb-6 border-b border-white/10 pb-4" data-id="element-154">
              VALORE TOTALE DEI CONTENUTI:
            </p>

            <ul className="space-y-4 mb-8" data-id="element-155">
              {[{
              name: '6 Tomi del Sistema (Tomo 1-6)',
              price: '€ 282'
            }, {
              name: '6 Bonus Esclusivi',
              price: '€ 102'
            }, {
              name: 'Accesso immediato e download istantaneo',
              price: 'Incluso'
            }, {
              name: "Tutti i prompt pronti all'uso",
              price: 'Incluso'
            }].map((item, i) => <li key={i} className="flex justify-between items-center text-gray-300" data-id="element-156">
                  <span className="flex items-center gap-2" data-id="element-157">
                    <Check className="w-4 h-4 text-emerald-500" data-id="element-158" />
                    {item.name}
                  </span>
                  <span className="font-medium" data-id="element-159">{item.price}</span>
                </li>)}
            </ul>

            <div className="border-t border-white/10 pt-6 mb-8 flex justify-between items-center" data-id="element-160">
              <span className="text-gray-400 font-medium" data-id="element-161">VALORE TOTALE:</span>
              <span className="text-xl text-gray-500 line-through decoration-red-500/50 decoration-2 font-bold" data-id="element-162">
                € 384,00
              </span>
            </div>

            <div className="text-center space-y-2 mb-8 bg-dark-900/50 p-6 rounded-2xl border border-white/5" data-id="element-163">
              <p className="text-gold-400 font-bold tracking-widest uppercase text-sm" data-id="element-164">
                SOLO OGGI
              </p>
              <div className="flex items-start justify-center gap-1" data-id="element-165">
                <span className="text-3xl font-bold text-white mt-2" data-id="element-166">€</span>
                <span className="text-7xl font-black text-white tracking-tighter" data-id="element-167">
                  19
                </span>
                <span className="text-3xl font-bold text-white mt-2" data-id="element-168">,90</span>
              </div>
            </div>

            <div className="flex flex-col items-center gap-2 text-sm text-gray-400 font-medium mb-8 text-center" data-id="element-169">
              <p data-id="element-170">
                💳 Pagamento unico • ⚡ Accesso immediato • 📥 Download
                istantaneo
              </p>
              <p className="text-red-400 flex items-center gap-1" data-id="element-171">
                <Clock className="w-4 h-4" data-id="element-172" /> Prezzo speciale di lancio — salirà
                a breve
              </p>
            </div>

            <a href="https://italia.recursopack.com/cart/40988178776113:1" target="_blank" rel="noopener noreferrer" className="w-full group relative inline-flex items-center justify-center px-8 py-5 text-lg font-bold text-white transition-all duration-200 bg-gradient-to-b from-emerald-400 to-emerald-600 border-b-4 border-emerald-800 rounded-xl hover:from-emerald-300 hover:to-emerald-500 hover:-translate-y-1 active:translate-y-0 active:border-b-0 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500 focus:ring-offset-dark-900 shadow-[0_0_40px_rgba(16,185,129,0.3)] hover:shadow-[0_0_60px_rgba(16,185,129,0.5)] no-underline" data-id="element-173">
              <span className="flex items-center gap-2 text-xl tracking-wide uppercase text-shadow-sm" data-id="element-174">
                ✅ ACQUISTA ORA — € 19,90
              </span>
            </a>
            <div className="mt-6 grid grid-cols-2 gap-3 text-xs text-gray-400 font-medium" data-id="element-175">
              <div className="flex items-center gap-2 justify-center bg-dark-800/50 rounded-lg p-2 border border-white/5" data-id="element-176">
                🔒 Acquisto sicuro
              </div>
              <div className="flex items-center gap-2 justify-center bg-dark-800/50 rounded-lg p-2 border border-white/5" data-id="element-177">
                📥 Download immediato
              </div>
              <div className="flex items-center gap-2 justify-center bg-dark-800/50 rounded-lg p-2 border border-white/5" data-id="element-178">
                💳 Pagamento unico €19,90
              </div>
              <div className="flex items-center gap-2 justify-center bg-dark-800/50 rounded-lg p-2 border border-white/5" data-id="element-179">
                🛡️ Garanzia 7 giorni
              </div>
            </div>
          </div>
        </div>

        {/* Guarantee */}
        <div className="max-w-3xl mx-auto glass-panel p-8 md:p-10 rounded-3xl flex flex-col md:flex-row items-center gap-8 text-center md:text-left border-emerald-500/30 mb-20 relative overflow-hidden" data-id="element-180">
          <div className="absolute top-0 right-0 w-64 h-64 bg-emerald-500/5 rounded-full blur-3xl pointer-events-none blur-glow" data-id="element-181"></div>
          <div className="w-20 h-20 rounded-full bg-emerald-500/10 flex items-center justify-center shrink-0 border border-emerald-500/20 relative z-10" data-id="element-182">
            <ShieldCheck className="w-10 h-10 text-emerald-400" data-id="element-183" />
          </div>
          <div className="relative z-10" data-id="element-184">
            <h3 className="text-2xl font-bold text-white mb-3" data-id="element-185">
              GARANZIA TOTALE 7 GIORNI — RISCHIO ZERO
            </h3>
            <p className="text-gray-300 text-base leading-relaxed" data-id="element-186">
              Hai 7 giorni completi per usare tutto il sistema. Se non hai
              risparmiato almeno 2 ore di lavoro, se non ti senti più
              organizzato, più sicuro e più efficiente, ti restituiamo ogni
              centesimo.{' '}
              <span className="text-white font-bold" data-id="element-187">
                Senza domande. Senza discussioni.
              </span>{' '}
              Il rischio è tutto nostro. Il risultato è tutto tuo.
            </p>
          </div>
        </div>

        {/* About */}
        <div className="max-w-3xl mx-auto mb-20 text-center" data-id="element-188">
          <div className="relative w-64 h-64 mx-auto mb-8" data-id="element-189">
            <div className="absolute inset-0 bg-gold-500/10 blur-[60px] rounded-full pointer-events-none blur-glow" data-id="element-190"></div>
            <img src={HERO_IMAGE} alt="Docente PRO Bundle" width={1080} height={1080} loading="lazy" className="relative z-10 w-full h-full object-contain drop-shadow-2xl" data-id="element-191" />
          </div>
          <h3 className="text-xl font-bold text-white mb-6 uppercase tracking-widest" data-id="element-192">
            Una promessa ai docenti italiani
          </h3>
          <p className="text-xl md:text-2xl text-gray-400 italic leading-relaxed font-serif" data-id="element-193">
            "Hai scelto di insegnare per fare la differenza. Non per annegare
            nella burocrazia. Abbiamo creato Docente PRO per restituirti il
            tempo, l'energia e la passione che meriti."
          </p>
        </div>

        {/* FAQ */}
        <div className="max-w-3xl mx-auto mb-20" data-id="element-194">
          <h2 className="text-3xl font-bold text-center text-white mb-10" data-id="element-195">
            Domande Frequenti
          </h2>
          <div className="space-y-4" data-id="element-196">
            {faqs.map((faq, index) => <div key={index} className="glass-panel rounded-xl border-white/5 overflow-hidden transition-all duration-300" data-id="element-197">
                <button onClick={() => toggleFaq(index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none hover:bg-white/[0.02] transition-colors" data-id="element-198">
                  <span className="text-lg font-semibold text-white pr-4" data-id="element-199">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-gold-400 shrink-0 transition-transform duration-300 ${openFaq === index ? 'rotate-180' : ''}`} data-id="element-200" />
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openFaq === index ? 'max-h-60 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-201">
                  <p className="text-gray-400 leading-relaxed border-t border-white/5 pt-4" data-id="element-202">
                    {faq.a}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        {/* Final CTA */}
        <div className="mb-10" data-id="element-203">
          <CTAButton subtext="⚡ Accesso Immediato • 📥 Download Istantaneo • 🛡️ Garanzia 7 Giorni" scrollTo="offerta" data-id="element-204">
            ✅ SÌ, VOGLIO DOCENTE PRO ADESSO
          </CTAButton>
          <p className="text-center text-gray-400 max-w-xl mx-auto mt-4 text-sm" data-id="element-205">
            Unisciti ai docenti italiani che hanno già scelto di lavorare
            meglio, insegnare di più e vivere di più.
          </p>
        </div>
      </main>

      <footer className="mt-12 border-t border-white/5 pt-12 pb-8 px-4 text-center" data-id="element-206">
        <div className="max-w-2xl mx-auto space-y-6" data-id="element-207">
          <div className="flex items-center justify-center gap-2 text-gray-400 font-bold text-lg" data-id="element-208">
            <GraduationCap className="w-5 h-5" data-id="element-209" /> Docente PRO Italia
          </div>
          <p className="text-gray-500 text-sm leading-relaxed" data-id="element-210">
            Il primo sistema completo in italiano per docenti che vogliono usare
            l'IA per lavorare meno, insegnare meglio e ritrovare la loro vita.
          </p>
          <p className="text-gray-600 text-xs pt-4" data-id="element-211">
            © Docente PRO 2026 — Tutti i diritti riservati.
          </p>
        </div>
      </footer>

      <SocialProofPopup data-id="element-212" />
    </div>;
}